import clsx from 'clsx'
import { useEffect, useRef } from 'react'

interface Props {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const textSize: Record<string, string> = { sm: 'text-lg', md: 'text-2xl', lg: 'text-[2.5rem]' }

export default function Spinner({ className, size = 'md' }: Props) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const anim = el.animate(
      [{ opacity: 0.35 }, { opacity: 1 }, { opacity: 0.35 }],
      { duration: 3000, iterations: Infinity, easing: 'ease-in-out' },
    )
    return () => anim.cancel()
  }, [])

  return (
    <div className={clsx('flex items-center justify-center py-20', className)}>
      <div ref={ref} className={clsx('font-black tracking-tight select-none', textSize[size])} style={{ willChange: 'opacity' }}>
        <span className="text-gray-800">My</span>
        <span style={{ color: 'var(--color-fom-500, #00c6b2)' }}>FOM</span>
      </div>
    </div>
  )
}
